<template>
  <custom-callout
    :has-toggle="false"
    :has-border="false"
    class="mb-3"
    :opened="isPanelOpen"
    :controlled="true"
  >
    <div class="row m-0 d-flex align-items-center py-2">
      <div class="col-md-3 col-12 mb-lg-0 border-right">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Título del Libro:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.name | empty }}
        </div>
      </div>
      <div class="col-md-3 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Materia:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.subject.name | empty }}
        </div>
      </div>
      <div class="col">
        <action-button
          id="btnSelect"
          :i="
            isPanelOpen
              ? 'far fa-check'
              : item.disabled
              ? 'far fa-check text-disabled'
              : 'far fa-check text-success'
          "
          :text="isPanelOpen ? 'Seleccionado' : 'Seleccionar'"
          :disabled="item.disabled"
          :class="'float-md-right mr-2'"
          :variant="
            isPanelOpen
              ? 'ab-btn ab-btn-success pt-2'
              : item.disabled
              ? 'outline-disabled'
              : 'outline-success'
          "
          @click="selectItem()"
        />
      </div>
    </div>
    <template #edition>
      <div class="py-2 px-5 ml-2">
        <div class="mb-2">
          <inner-page-message
            :visible="isAlertVisible"
            :message="alertMessage"
            isHtml
          />
        </div>
        <validation-observer
          ref="form"
          novalidate
          tag="form"
          :key="model.reason?.id"
        >
          <div class="row mb-1">
            <div
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.reason"
                    :options="reasons"
                    label="Razón:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                    @input="onReasonChange()"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.readingMedium"
                    :options="readingMediums"
                    label="Medio de Lectura:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                    @input="existBook"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              v-if="isPlanningNextYearReasonSelected"
              class="col-md-4 col-12"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-input
                    v-model="model.quantity"
                    type="number"
                    class="w-100"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                    label="Cantidad de Libro(s) a Solicitar:"
                    placeholder="Cantidad de Libro(s) a Solicitar"
                  />
                </validation-provider>
              </div>
            </div>
            <div v-if="isAsignStudentReasonSelected" class="col-md-4 col-12">
              <div class="form-group">
                <div class="d-flex flex-row justify-content-between">
                  <div class="w-75">
                    <custom-input
                      v-model="sieInput"
                      type="number"
                      class="w-100"
                      label="SIE del Estudiante:"
                      placeholder="Escriba Número de SIE"
                      icon="fas fa-search text-orange"
                      left-icon
                    />
                  </div>
                  <div class="d-flex align-items-end justify-content-end">
                    <action-button
                      id="btnSave"
                      i="fas fa-file-plus"
                      text="Añadir"
                      :variant="
                        canAddStudent && !loadingStudent
                          ? 'success'
                          : 'secondary'
                      "
                      :disabled="loadingStudent || !canAddStudent"
                      @click="addStudent"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.grade"
                    :options="grades"
                    label="Grado:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                    @input="existBook"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.publisher"
                    :options="publishers"
                    label="Casa Editorial:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.author"
                    :options="authors"
                    label="Autor:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              v-if="!isMaster"
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.center"
                    :options="centers"
                    label="Centro:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100  bold-label"
                    @input="getMunicipalities"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              v-if="!isMaster"
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.municipality"
                    :options="municipalities"
                    label="Municipio:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100  bold-label"
                    @input="getSchools"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              v-if="!isMaster"
              class="col-md-3 col-12"
              :class="{
                'col-md-4':
                  isAsignStudentReasonSelected ||
                  isPlanningNextYearReasonSelected
              }"
            >
              <div class="form-group">
                <validation-provider
                  mode="eager"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    v-model="model.school"
                    :options="schools"
                    label="Escuela:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    class="w-100 bold-label"
                    custom-error-msg="Este campo es requerido"
                    :error="errors[0]"
                  />
                </validation-provider>
              </div>
            </div>
            <div v-if="isPlanningNextYearReasonSelected" class="col-12">
              <div class="form-group">
                <div class="d-flex flex-row justify-content-between">
                  <div class="flex-fill pr-4">
                    <custom-input
                      v-model="sieInput"
                      type="number"
                      class="w-100"
                      label="SIE del Estudiante:"
                      placeholder="Escriba Número de SIE"
                      icon="fas fa-search text-orange"
                      left-icon
                    />
                  </div>
                  <div class="d-flex align-items-end justify-content-end">
                    <action-button
                      id="btnSave"
                      i="fas fa-file-plus"
                      text="Añadir"
                      :variant="
                        canAddStudent && !loadingStudent
                          ? 'success'
                          : 'secondary'
                      "
                      :disabled="loadingStudent || !canAddStudent"
                      @click="addStudent"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="hasStudentsSelected" class="mb-4 mt-1">
            <icon-view
              icon="fas fa-user-circle fa-lg text-orange"
              :title="
                isAsignStudentReasonSelected
                  ? 'Estudiante Seleccionado'
                  : 'Estudiante(s) Seleccionado(s)'
              "
              variant="custom-icon-view"
              icon-background="white"
            />
            <div
              class="my-3 px-3"
              v-for="(student, sKey) in model.students"
              :key="sKey"
            >
              <div
                class="row font-weight-normal p-3 bg-white rounded border-left-4"
              >
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14">
                    Nombre del Estudiante:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ student.fullName | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    SIE:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ student.studentId | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    Edad:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ `${student.age}`.split(".")[0] | empty }}
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="color-secondary-6 font-14">
                    Impedimento:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ student.impediment | empty }}
                  </div>
                </div>
                <div class="col-md col-12">
                  <div class="color-secondary-6 font-14">
                    Estatus:
                  </div>
                  <div class="color-black font-16 text-break">
                    {{ student.status | empty }}
                  </div>
                </div>
                <div
                  class="col-md-1 col-12 d-flex align-items-center justify-content-end"
                >
                  <action-button
                    i="fas fa-times-circle"
                    variant="outline-danger"
                    @click="quitStudent(sKey)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                label="Comentario:"
                v-model="model.comment"
                :count-classes="['d-block', 'small-counter', 'text-right']"
                custom-error-msg="Este campo es requerido"
                :error="errors[0]"
                :maxlength="3000"
                placeholder="Escriba un comentario"
                show-char-count
              />
            </validation-provider>
          </div>
          <div class="d-flex justify-content-end mb-3">
            <div class="mt-3 mt-md-0">
              <div
                class="d-flex justify-content-end h-100"
                :class="{ 'flex-column': isMobile }"
              >
                <div :class="{ 'w-100 mb-2': isMobile }">
                  <action-button
                    id="btnCancel"
                    i="fas fa-times-circle"
                    text="Cancelar"
                    :variant="
                      isMobile
                        ? 'outline-danger mr-2 w-100'
                        : 'outline-danger mr-2 mt-2'
                    "
                    @click="cancel"
                  />
                </div>
                <div :class="{ 'w-100': isMobile }">
                  <action-button
                    id="btnSave"
                    i="fas fa-file-plus"
                    text="Guardar"
                    :variant="isMobile ? 'success w-100' : 'success mt-2'"
                    @click="save"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import CustomInput from "CustomInput";
import IconView from "icon-view";
import InnerPageMessage from "@/components/common/page/InnerPageMessage.vue";

import alertMixin from "@/mixin/alert.mixin";

import StudentStatuses from "@/utils/constants/student/studentStatuses.js";
import InventoryOrderBooksReasons from "@/utils/constants/inventory/inventoryOrderBooksReasons.js";

import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import studentApi from "@/services/student.js";
import locationService from "@/services/api/location.api";
import userRole from "@/utils/constants/userRoles";
import resourcesService from '@/services/resources.js';

export default {
  name: "ResultRow",
  mixins: [alertMixin],
  components: {
    CustomCallout,
    DropDown,
    CustomDropDown,
    ActionButton,
    CustomTextArea,
    CustomInput,
    IconView,
    InnerPageMessage
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    reasons: {
      type: Array,
      required: true,
      default: []
    },
    readingMediums: {
      type: Array,
      required: true,
      default: []
    },
    publishers: {
      type: Array,
      required: true,
      default: []
    },
    grades: {
      type: Array,
      required: true,
      default: []
    },
    authors: {
      type: Array,
      required: true,
      default: []
    },
    centers: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  async mounted() {
    if (this.centers.length === 1) {
      this.model.center = this.centers[0];
      this.getMunicipalities(this.centers[0]);
    }

    await this.loadResources();
  },
  watch: {
    async "model.quantity"(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        if (newVal < this.model.students.length) {
          this.model.quantity = Number(oldVal);
          this.ShowToast(
            "Error",
            "La cantidad de estudiantes seleccionados es mayor a la nueva cantidad de libro(s) a solicitar, favor de remover los estudiantes.",
            "error"
          );
          return;
        }
      }
    }
  },
  data() {
    return {
      model: {
        reason: null,
        readingMedium: null,
        publisher: null,
        grade: null,
        author: null,
        comment: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        students: []
      },
      municipalities: [],
      schools: [],
      sieInput: "",
      alertMessage: null,
      isAlertVisible: false,
      loadingStudent: false,
      resources: []
    };
  },
  computed: {
    actionItems() {
      return [
        {
          name: this.isPanelOpen ? "Seleccionado" : "Seleccionar",
          icon: this.isPanelOpen ? "far fa-check" : "far fa-check text-success",
          class: this.isPanelOpen ? "ab-btn ab-btn-success pt-2" : "",
          visible: !this.item.disabled,
          click: () => this.selectItem()
        }
      ];
    },
    isMaster() {
      return [userRole.maestro, userRole.maestroPrivado].includes(
        this.userRole
      );
    },
    hasMunicipality() {
      return Boolean(this.model.municipality);
    },
    isPanelOpen() {
      return this.item.isOpen;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isAsignStudentReasonSelected() {
      return this.model.reason?.id === InventoryOrderBooksReasons.AssignStudent;
    },
    isPlanningNextYearReasonSelected() {
      return (
        this.model.reason?.id ===
        InventoryOrderBooksReasons.PlanningNextSchoolYear
      );
    },
    canAddStudent() {
      const isValidSie =
        this.sieInput?.length === 8 && Number.isInteger(Number(this.sieInput));

      const maxStudentSelected = this.isPlanningNextYearReasonSelected
        ? this.model.quantity > 0 &&
          this.model.students.length >= this.model.quantity
        : this.hasStudentsSelected;

      const validRules = [isValidSie, !maxStudentSelected];
      return validRules.every(x => x);
    },
    hasStudentsSelected() {
      return this.model.students.length > 0;
    },
    academicYearId() {
      return this.currentAcademicYear().id;
    }
  },
  methods: {
    async selectItem() {
      await this.onToggle();
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(["44"]);
    },
    async onToggle() {
      if (this.item.isOpen) {
        this.isOpen = false;

        this.$emit("close", this.item);
        return;
      }

      this.$emit("open", this.item);
    },
    clear() {
      this.model = {
        reason: null,
        readingMedium: null,
        publisher: null,
        grade: null,
        author: null,
        comment: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        students: []
      };
    },
    async cancel() {
      this.clear();
      await this.onToggle();
    },
    async onReasonChange() {
      this.model = {
        ...this.model,
        readingMedium: null,
        publisher: null,
        grade: null,
        author: null,
        comment: null,
        quantity: null,
        center: null,
        municipality: null,
        school: null,
        students: []
      };

      await this.existBook();
      if (this.centers.length === 1) {
        this.model.center = this.centers[0];
        this.getMunicipalities(this.centers[0]);
      }
    },
    async addStudent() {
      if (this.isPlanningNextYearReasonSelected && this.model.quantity < 1) {
        this.ShowToast(
          "Error",
          "Se debe documentar la cantidad de libro(s) a solicitar.",
          "error"
        );
        return;
      }

      if (this.model.students.some(x => x.studentId == this.sieInput)) {
        this.ShowToast(
          "Error",
          "El estudiante se encuentre registrado.",
          "error"
        );
        return;
      }

      if (!this.canAddStudent) return;
      this.loadingStudent = true;
      try {
        const { data } = await studentApi.getBySie(this.sieInput);
        if (!data.canAccess) throw new Error(this.resources["44"]);

        if (data.statusId !== StudentStatuses.Servido)
          throw new Error("El estudiante debe estar en el estatus de Servido.");

        this.model.students.push(data);
        this.sieInput = null;
        this.loadingStudent = false;
      } catch (error) {
        this.ShowToast(
          "Error",
          error?.message ?? error?.response?.data?.message,
          "error"
        );
        this.loadingStudent = false;
      }
    },
    quitStudent(index) {
      this.model.students.splice(index, 1);
    },
    async existBook() {
      this.isAlertVisible = false;

      if (!this.model.grade?.id || !this.model.readingMedium?.id) return;
      const { data } = await inventoryOrderBooksService.existBook({
        catalogId: this.item.id,
        subjectId: this.item.subject.id,
        gradeId: this.model.grade.id,
        readingMedium: this.model.readingMedium.name
      });
      this.isAlertVisible = data;
      if (data)
        this.alertMessage = `Libro disponible por las entregas del año académico anterior: “Según los criterios solicitados, la escuela cuenta con el libro disponible del año académico anterior”<br>¿Desea proceder con esta solicitud?`;
    },
    async save() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada.",
          "error"
        );
        return;
      }

      if (this.isAsignStudentReasonSelected && this.model.students.length < 1) {
        this.ShowToast(
          "Error",
          "Favor de seleccionar al menos un estudiante.",
          "error"
        );
        return;
      }

      if (
        this.isPlanningNextYearReasonSelected &&
        Number(this.model.quantity) < this.model.students.length
      ) {
        this.ShowToast(
          "Error",
          "La cantidad de estudiantes seleccionados es mayor a la cantidad de libro(s) a solicitar, favor de remover los estudiantes.",
          "error"
        );
        return;
      }

      let confirmation = await this.ShowCancelModal(
        "Atención",
        `¿Está seguro que desea guardar la información documentada?`,
        "Si",
        "No"
      );

      if (!confirmation) return !isValid;

      const payload = {
        catalogId: this.item.id,
        subjectId: this.item.subject.id,
        gradeId: this.model.grade.id,
        readingMediumId: this.model.readingMedium.id,
        publisherId: this.model.publisher.id,
        authorId: this.model.author.id,
        reasonId: this.model.reason.id,
        comment: this.model.comment,
        centerId: this.model.center?.id,
        municipalityId: this.model.municipality?.id,
        schoolId: this.model.school?.id,
        quantity:
          Number(this.model.quantity) > 0
            ? Number(this.model.quantity)
            : undefined,
        students: this.model.students.map(r => ({
          studentSieId: r.studentId
        }))
      };

      const { data } = await inventoryOrderBooksService
        .save(payload)
        .catch(() => {
          this.ShowToast(
            "Error",
            "Ha ocurrido un error al guardar la solicitud.",
            "error"
          );
        });

      if (data) {
        this.$emit("reload-seleted-items");
        this.cancel();
        this.ShowToast(
          "Éxito",
          "La solicitud se ha guardado correctamente.",
          "success"
        );
      }
    },
    async getMunicipalities(center = null) {
      this.model.municipality = null;
      this.municipalities = [];
      this.model.school = null;
      this.schools = [];

      if (!center) return;

      const { data } = await locationService.getMunicipalities({
        academicYearId: this.academicYearId,
        centerId: center.id
      });
      this.municipalities = data;

      if (data.length === 1) {
        this.model.municipality = data[0];
        this.getSchools(data[0]);
      }
    },
    async getSchools(municipality = null) {
      this.model.school = null;
      this.schools = [];

      if (!municipality) return;

      const { data } = await locationService.getSchools({
        academicYearId: this.academicYearId,
        municipalityId: municipality.id
      });

      this.schools = data;

      if (data.length === 1) {
        this.model.school = data[0];
      }
    }
  }
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

::v-deep .ab-btn-success {
  color: map.get($colors, "white") !important;
  background-color: map.get($colors, "green") !important;
  border-color: map.get($colors, "green") !important;
}
::v-deep .autocomplete-result-list {
  z-index: 2 !important;
}

::v-deep .ab-btn-outline-disabled {
  color: #b5c3bc !important;
  background-color: #fff !important;
  border-color: #b5c3bc !important;
}

::v-deep .text-disabled {
  color: #b5c3bc !important;
}
.border-left-4 {
  border-left: 4px solid #b5c3bc !important;
}
</style>
